import { CONFIGURATION_SERVICE, IConfigurationService } from '../../@posturinn/common-react/core';
import { Injectable, Provider } from '../../@posturinn/common-react/injection';
import { MOBIZ_API_URL } from '../../constants/paths/api';

export const CLIENT_ID = navigator.userAgent === 'skraningartolva' ? 'posturinn-postoffice' : 'posturinn-web';
@Injectable()
export class AppConfigurationService implements IConfigurationService {
	public readonly apiVersion: string = 'v1';
	public readonly clientId: string = CLIENT_ID;
	// TODO: CHANGE
	public readonly clientVersion: string = '1.0.0';
	public readonly baseUrl: string = MOBIZ_API_URL;
}

export const CONFIGURATION_SERVICE_PROVIDERS: Provider[] = [
	{
		provide: CONFIGURATION_SERVICE,
		useClass: AppConfigurationService,
	},
];

export const clientIdConfig = {
	headers: {
		'x-clientId': CLIENT_ID,
	},
};
